import classes from './styles.module.scss';
import IntroImage from '../../assets/images/member-application-form/group_people_img.png'

import { useContext, useEffect, useRef, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { IsNullOrEmpty, IsNullOrZero, IsOnlyLetters, IsSelectEmpty, IsValidEmail, IsValidTckn, ParseDate } from '../../core/utility';
import ReCAPTCHA from "react-google-recaptcha";
import { post } from '../../core/client';
import Grid from '@mui/material/Grid';
import Box from '@mui/system/Box';
import Checkbox from '@mui/material/Checkbox';
import Alert from '@mui/material/Alert';
import { CheckCircleOutlineRounded } from '@mui/icons-material';
import { ResponseWithSuccess } from '../../core/client/Models';
import FormControlLabel from '@mui/material/FormControlLabel';
import { CustomButton } from '../../components/buttons';
import Select from '../../components/inputs/select';
import Input from '../../components/inputs/text-field-input';
import DatePicker from '../../components/inputs/date-picker';
import SmsCodeModal from '../shared/SmsCodeModal';
import JoinFormV2ContextProvider, { JoinFormV2Context, LegalContractConsentType } from '../shared/JoinFormV2Context';
import reactStringReplace from 'react-string-replace';
import WarningModal from '../../components/warning-modal';


interface StateModel {
    companyId: number;
    companyName: string;
    tcIdentityNo: string;
    firstName: string;
    lastName: string;
    phoneArea: string | null;
    phone: string;
    birthDate: any;
    email: string;
    reCaptchaToken: string;
    //ileti izni
    commPerm: boolean;
    //kişisel veri paylaşım izni
    approvedConsents: Array<string>
}

interface FormInfo {
    userId: number;
    companyId: number;
    companyName: string;
    tcIdentityNo: string;
    firstName: string;
    lastName: string;
    birthDate: string;
}

interface InputErrorModel {
    name: string;
    errorText: string;
}

interface SelectItem {
    name: string;
    value: string
}

type KeyValue = {
    key: string;
    value: string;
}

const initialState: StateModel = {
    companyId: 0,
    companyName: '',
    tcIdentityNo: '',
    firstName: '',
    lastName: '',
    phoneArea: null,
    phone: '',
    birthDate: '',
    email: '',
    commPerm: false,
    approvedConsents: [],
    reCaptchaToken: ''
}

const MemberApplicationFormComponent = () => {

    const { legalTextLoading, legalTexts, loadLegalTexts, openLegalTextModal } = useContext(JoinFormV2Context);

    const [searchParams, setSearchParams] = useSearchParams();

    const params: KeyValue[] = [];

    searchParams.forEach((value, key) => {
        params.push({ key, value });
    });

    const [state, setState] = useState<StateModel>(initialState);
    const [loading, setLoading] = useState(false);
    const [loadingSendForm, setLoadingSendForm] = useState(false);
    const [errorText, setErrorText] = useState('');
    const [inputErrors, setInputErrors] = useState<Array<InputErrorModel>>([]);
    const [isKvkkError, setIsKvkkError] = useState(false);
    const [phoneAreas, setPhoneAreas] = useState<SelectItem[]>([]);
    const [showSmsCodeModal, setShowSmsCodeModal] = useState(false);
    const [isTcknDisabled, setIsTcknDisabled] = useState(false);
    const [sendSuccess, setSendSuccess] = useState(false);

    const [openPopup, setOpenPopup] = useState<boolean>(false);
    const [message, setMessage] = useState<string>('');

    const handleWarnigOpen = (msg: string) => {
        setMessage(msg);
        setOpenPopup(true);
    };

    const handleWarningClose = () => setOpenPopup(false);

    const recaptchaRef = useRef<any>(null);

    const formElRef = useRef<any>(null);

    useEffect(() => {
        loadPhoneAreas();

        if (params && params.length > 0) {
            getFormValues(params);
            loadLegalTexts([
                LegalContractConsentType.VERI_IZNI,
                LegalContractConsentType.YKB_VERI_AKTARIM_IZNI,
                LegalContractConsentType.ETK_IZNI,
                LegalContractConsentType.YURT_DISI_VERI_IZNI,
                LegalContractConsentType.UYELIK_SOZLESMESI,
                LegalContractConsentType.YKB_AYDINLATMA,
            ])
        }
    }, []);

    const getFormValues = async (params: KeyValue[]) => {
        setLoading(true);
        const { data, fail, errorMessage } = await post<{ formInfo: FormInfo }>('api/membership/get-member-application-form-info', { params });
        setLoading(false);
        if (data) {
            const formInfo = data.formInfo;
            setState(prev => ({
                ...prev,
                tcIdentityNo: formInfo.tcIdentityNo ?? '',
                firstName: formInfo.firstName,
                lastName: formInfo.lastName,
                birthDate: formInfo.birthDate ? ParseDate(formInfo.birthDate) : null,
                companyId: formInfo.companyId,
                companyName: formInfo.companyName
            }))
            setIsTcknDisabled(!IsNullOrEmpty(formInfo.tcIdentityNo));
        }
        if (fail) {
            setErrorText(errorMessage);
        }
    }

    const handleScroll = (e: any) => {
        e.preventDefault();

        formElRef.current?.scrollIntoView({ behavior: 'smooth' });
    }

    const loadPhoneAreas = () => {
        let list: number[] = [501, 505, 506, 507, 516];
        for (let i = 530; i < 562; i++) {
            list.push(i);
        }
        const result: SelectItem[] = list.map(x => ({ name: x.toString(), value: x.toString() }));
        setPhoneAreas(result);
    }

    const handleChange = (e: any) => {
        setState(prev => ({
            ...prev,
            [e.target.name]: e.target.value
        }))
    }

    const onChangeCaptcha = async (e: any) => {
        setState(prev => ({
            ...prev,
            reCaptchaToken: e
        }));
    }

    const toggleSmsModal = (show: boolean) => {
        setShowSmsCodeModal(show);
    }

    const handleMembershipAggreement = () => {
        openLegalTextModal(LegalContractConsentType.UYELIK_SOZLESMESI);
    }

    const handleYkbAggreement = () => {
        openLegalTextModal(LegalContractConsentType.YKB_AYDINLATMA);
    }

    const handleConsentCheckbox = (e: any) => {
        const consentType = e.target.name;
        let consents: Array<string> = [...state.approvedConsents];
        consents = consents.filter(x => x !== consentType);

        if (e.target.checked) {
            consents = [...consents, consentType];

            if (consentType === LegalContractConsentType.VERI_IZNI
                || consentType === LegalContractConsentType.YURT_DISI_VERI_IZNI
                || consentType === LegalContractConsentType.VAKIF_DERNEK_IZNI
            ) {
                openLegalTextModal(consentType as LegalContractConsentType);
            }
        }
        setState(prev => ({
            ...prev,
            approvedConsents: consents,
        }));
    }
    const isConsentApproved = (type: string) => {
        return state.approvedConsents.some(consent => consent === type);
    }

    const isRequiredConsentsChecked = (model: StateModel) => {
        const requiredConsents = legalTexts?.consents.filter(x => x.required
            && x.type !== LegalContractConsentType.UYELIK_SOZLESMESI
            && x.type !== LegalContractConsentType.YKB_AYDINLATMA
        );
        if (requiredConsents) {

            for (let item of requiredConsents) {
                if (!isConsentApproved(item.type)) {
                    return;
                }
            }
        }
        return true;
    }

    const setError = (name: keyof StateModel, errorText = 'Zorunlu alan') => {
        const error: InputErrorModel = { name, errorText };
        setInputErrors((prev: Array<InputErrorModel>) => [...prev, error]);
    }

    const validate = (model: StateModel): boolean => {

        setIsKvkkError(false);
        setInputErrors([]);

        let isValid = true;

        if (IsNullOrZero(model.companyId)) {
            setError('companyId');
            isValid = false;
        }
        if (!IsValidTckn(model.tcIdentityNo)) {
            setError('tcIdentityNo', 'Geçersi TC kimlik no');
            isValid = false;
        }
        if (IsNullOrEmpty(model.firstName) || !IsOnlyLetters(model.firstName)) {
            setError('firstName', 'Geçersiz ad');
            isValid = false;
        }
        if (IsNullOrEmpty(model.lastName) || !IsOnlyLetters(model.lastName)) {
            setError('lastName', 'Geçersiz soyad');
            isValid = false;
        }
        if (IsNullOrEmpty(model.birthDate)) {
            setError('birthDate', 'Geçersiz doğum tarihi');
            isValid = false;
        }
        if (IsSelectEmpty(model.phoneArea)) {
            setError('phoneArea');
            isValid = false;
        }
        if (IsNullOrEmpty(model.phone) || model.phone.length !== 7) {
            setError('phone', 'Geçersiz telefon');
            isValid = false;
        }
        if (!IsValidEmail(model.email)) {
            setError('email', 'Geçersiz e-posta');
            isValid = false;
        }
        if (!isRequiredConsentsChecked(model)) {
            setIsKvkkError(true);
            isValid = false;
        }

        return isValid;
    }

    const handleSend = async (model: StateModel) => {

        if (!validate(model)) return;
        setLoadingSendForm(true);
        const request = {
            companyId: model.companyId,
            tcIdentityNo: model.tcIdentityNo,
            firstName: model.firstName,
            lastName: model.lastName,
            birthDate: model.birthDate,
            phone: `90${model.phoneArea}${model.phone}`,
            email: model.email,
            reCaptchaToken: model.reCaptchaToken
        }
        const { data, fail, errorMessage } = await post<ResponseWithSuccess>('api/membership/validate-member-application-form', request);
        setLoadingSendForm(false);
        if (data && data.success) {
            toggleSmsModal(true);
        }

        if (fail) {
            setErrorText(errorMessage);
        }

        recaptchaRef.current.reset();
    }

    const handleSmsValidated = async (code: string, model: StateModel) => {

        setSendSuccess(false);
        setErrorText('');

        setLoadingSendForm(true);
        const request = {
            smsCode: code,
            companyId: model.companyId,
            tcIdentityNo: model.tcIdentityNo,
            firstName: model.firstName,
            lastName: model.lastName,
            birthDate: model.birthDate,
            phone: `90${model.phoneArea}${model.phone}`,
            email: model.email,
            isApprovedVeriIzni: isConsentApproved(LegalContractConsentType.VERI_IZNI),
            isApprovedYkbAktarim: isConsentApproved(LegalContractConsentType.YKB_VERI_AKTARIM_IZNI),
            commPermStatus: isConsentApproved(LegalContractConsentType.ETK_IZNI),
        }
        const { data, fail, errorMessage } = await post<ResponseWithSuccess>('api/membership/complete-member-application-form', request);
        setLoadingSendForm(false);
        if (data && data.success) {
            setSendSuccess(true);
        }
        else {
            handleWarnigOpen('İşleminiz tamamlanamadı. Bilgi almak için 444 0 447 numaralı KoçAilem Çağrı Merkezi ile iletişime geçebilirsiniz. ');      
            return;
        }

        if (fail) {
            setErrorText(errorMessage);
        }
    }

    return (
        <div className={classes.memberApplicationForm}>
            <div className={classes.overlay}>
                <div className={classes.section}>
                    <div className={`${classes.container} ${classes.paper} ${classes.introBox}`}>
                        <img src={IntroImage} alt='KoçAilem Üye Katılım Formu' />
                        <h1>Aramıza Hoş Geldin!</h1>
                        <p>Koçlu olmanın farkını şimdiden hissetmeye başla diye,<br />seni KoçAilemli olmaya davet ediyoruz.</p>
                        <p>KoçAilemliysen; <br />
Konforlu ve keyifli bir hayata "merhaba" dersin. En iyi restoranlarda yeni lezzetler keşfeder, vitrinde beğendiklerini gönlünce alır, market alışverişlerinde indirimli harcarsın. KoçAilem'le hayal ettiğin tatil senindir. İstediğin yere özel fiyatlarla uçar, konaklamadan vize işlemlerine kadar aile boyu indirimler kazanırsın. Dilediğin şehirde, istediğin aracı sana özel fiyatlarla kiralar, depoyu doldurur, indirimli ödersin. KoçAilemliysen sinemadan operaya, konserden tiyatroya, dilediğin etkinliğin tadını sana özel ayrıcalıklarla çıkarırsın. 
<br /><br />KoçAilem'le hayatı doyasıya yaşarsın; çünkü "Aileden Ayrıcalıklısın"</p>
                        <a
                            id="gotoForm"
                            className={classes.button}
                            href="#uyelik"
                            onClick={handleScroll}
                        >Hemen KoçAilemli Ol</a>
                    </div>
                </div>
                <div className={classes.section} ref={formElRef}>
                    <div className={`${classes.container} ${classes.paper} ${classes.formBox}`}>
                        <h1>KoçAilem Üyelik Formu</h1>
                        {
                            sendSuccess ? (
                                <div className={classes.successMessage}>
                                    <CheckCircleOutlineRounded className={classes.successIcon} />
                                    <h3>Tebrikler!</h3>
                                    <h4>Üyelik formu başarıyla gönderildi!</h4>
                                </div>
                            ) : (
                                <>
                                    <Grid container spacing={2}>
                                        <Grid item sm={6} xs={12}>
                                            <Input
                                                id='companyName'
                                                name='companyName'
                                                caption='Şirket Adı'
                                                disabled
                                                value={state.companyName}
                                                errorText={inputErrors.find(x => x.name === 'companyId')?.errorText}
                                            />
                                            <input type='hidden' name='companyId' value={state.companyId} />
                                        </Grid>
                                        <Grid item sm={6} xs={12}>
                                            <Input
                                                id='tcIdentityNo'
                                                name='tcIdentityNo'
                                                caption='TC Kimlik No'
                                                patternFormat={{
                                                    format: '###########'
                                                }}
                                                disabled={isTcknDisabled}
                                                value={state.tcIdentityNo}
                                                onChange={handleChange}
                                                errorText={inputErrors.find(x => x.name === 'tcIdentityNo')?.errorText}
                                            />
                                        </Grid>
                                        <Grid item sm={6} xs={12}>
                                            <Input
                                                id='firstName'
                                                name='firstName'
                                                caption='Ad'
                                                toUpperCase
                                                value={state.firstName}
                                                onChange={handleChange}
                                                errorText={inputErrors.find(x => x.name === 'firstName')?.errorText}
                                            />
                                        </Grid>
                                        <Grid item sm={6} xs={12}>
                                            <Input
                                                id='lastName'
                                                name='lastName'
                                                caption='Soyad'
                                                toUpperCase
                                                value={state.lastName}
                                                onChange={handleChange}
                                                errorText={inputErrors.find(x => x.name === 'lastName')?.errorText}
                                            />
                                        </Grid>
                                        <Grid item sm={6} xs={12}>
                                            <DatePicker
                                                id='birthDate'
                                                name='birthDate'
                                                caption='Doğum Tarihi'
                                                value={state.birthDate}
                                                onChange={handleChange}
                                                errorText={inputErrors.find(x => x.name === 'birthDate')?.errorText}
                                            />
                                        </Grid>
                                        <Grid item sm={6} xs={12}>
                                            <Grid container spacing={1}>
                                                <Grid item xs={4}>
                                                    <Select
                                                        id="phoneArea"
                                                        name="phoneArea"
                                                        caption=""
                                                        disabled={loading}
                                                        loading={loading}
                                                        onChange={handleChange}
                                                        options={{
                                                            data: phoneAreas,
                                                            displayField: 'name',
                                                            displayValue: 'value',
                                                            selected: state.phoneArea
                                                        }}
                                                        errorText={inputErrors.find(x => x.name === 'phoneArea')?.errorText}
                                                    />
                                                </Grid>
                                                <Grid item xs={8}>
                                                    <Input
                                                        id='phone'
                                                        name='phone'
                                                        caption='Cep Telefon No'
                                                        patternFormat={{
                                                            format: '### ## ##',
                                                            mask: '_',
                                                        }}
                                                        value={state.phone}
                                                        onChange={handleChange}
                                                        errorText={inputErrors.find(x => x.name === 'phone')?.errorText}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        <Grid item sm={6} xs={12}>
                                            <Input
                                                id='email'
                                                name='email'
                                                caption='Kişisel E-Posta'
                                                value={state.email}
                                                onChange={handleChange}
                                                errorText={inputErrors.find(x => x.name === 'email')?.errorText}
                                            />
                                        </Grid>
                                    </Grid>
                                    <div className="py-3">
                                        {legalTextLoading ? (
                                            <p>Yükleniyor...</p>
                                        ) : (
                                            legalTexts?.consents
                                                .filter(x =>
                                                    x.type !== LegalContractConsentType.UYELIK_SOZLESMESI
                                                    && x.type !== LegalContractConsentType.YKB_AYDINLATMA).map((item, index) => (
                                                        <div className="py-1" key={index}>
                                                            <FormControlLabel
                                                                control={<Checkbox
                                                                    name={item.type} color="primary"
                                                                    checked={isConsentApproved(item.type)}
                                                                    onChange={handleConsentCheckbox}
                                                                />}
                                                                label={
                                                                    <div className={item.required && isKvkkError && !isConsentApproved(item.type) ?
                                                                        `${classes.errorCheckbox}` : ''} dangerouslySetInnerHTML={{ __html: item.text }}></div>
                                                                }
                                                            />
                                                        </div>
                                                    ))
                                        )}
                                    </div>

                                    {isKvkkError && (
                                        <Box marginBottom={2}>
                                            <Alert severity="error">Üyeliğinizi başlatmak için veri aktarım izinlerini kabul ediniz.</Alert>
                                        </Box>
                                    )}
                                    {!IsNullOrEmpty(errorText) && (
                                        <Box marginBottom={2}>
                                            <Alert severity="error">{errorText}</Alert>
                                        </Box>
                                    )}
                                    <Box display="flex" justifyContent="center" marginBottom={2}>
                                        <ReCAPTCHA
                                            ref={recaptchaRef}
                                            sitekey="6LdqH0QfAAAAAAQR10C9Poo7LItjCQ0Fbe2l9Fnn"
                                            onChange={onChangeCaptcha}
                                        />
                                    </Box>
                                    <Box marginBottom={2} textAlign="center">
                                        {
                                            reactStringReplace(
                                                legalTexts?.consents.find(x => x.type === LegalContractConsentType.YKB_AYDINLATMA)?.text ?? '',
                                                /<strong>(.*?)<\/strong>/,
                                                (match, i) => (
                                                    <button
                                                        style={{ color: '#177897', cursor: 'pointer', border: 'none' }}
                                                        onClick={handleYkbAggreement}>
                                                        <strong>{match}</strong></button>
                                                ))
                                        }
                                    </Box>
                                    <Box marginBottom={2} textAlign="center">
                                        'Formu Gönder' butonuna basılması ile <button style={{ color: '#177897', cursor: 'pointer', border: 'none' }} onClick={handleMembershipAggreement}><strong>Üyelik Sözleşmesi</strong></button>'ni okuduğunuzu ve kabul ettiğinizi onaylıyorsunuz.
                                    </Box>
                                    <Box display="flex" justifyContent="center">
                                        <CustomButton
                                            text="Formu Gönder"
                                            className="btn-primary"
                                            disabled={loading || loadingSendForm}
                                            loading={loadingSendForm}
                                            onClick={() => handleSend(state)} />
                                    </Box>
                                </>
                            )
                        }

                    </div>
                </div>
            </div>
            <SmsCodeModal
                show={showSmsCodeModal}
                phone={`0 (${state.phoneArea}) ${state.phone}`}
                onSend={(val: string) => handleSmsValidated(val, state)}
                onClose={() => toggleSmsModal(false)}
            />
             <WarningModal
                open={openPopup}
                message={message}
                handleClose={() => handleWarningClose()}
            />
        </div>
    );
}

const MemberApplicationForm = () => (
    <JoinFormV2ContextProvider>
        <MemberApplicationFormComponent />
    </JoinFormV2ContextProvider>
);

export default MemberApplicationForm;